export const CONTACT = {
  phone: "+91 99223 32604",
  phoneRaw: "+919922332604",
  whatsapp: "919922332604",
  email: "carbikesrental@gmail.com",
  website: "flyzonebikes.in",
  websiteUrl: "https://flyzonebikes.in",
  address: "Shop No 4, next to Asha Hotel, near Karve Statue, Chaitanya Nagar, Kothrud, Pune, Maharashtra 411038",
  hours: "Open Daily · 7:00 AM – 10:00 PM",
};

export const WHATSAPP_LINK = `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(
  "Hi Flyzone! I'd like to enquire about renting a vehicle."
)}`;

export const REVIEWS = [
  {
    name: "Marcus Reyes",
    role: "Daily Commuter",
    text: "Booked a scooter for a full month. Spotless, fuel-efficient, and the pickup took under five minutes. Flyzone made my commute effortless.",
    avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
  },
  {
    name: "Sofia Almeida",
    role: "Weekend Explorer",
    text: "The Phantom Sport 600 was a dream on the coastal highway. Helmet included, zero hidden fees. Easily the best rental experience I've had.",
    avatar: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
  },
  {
    name: "Daniel Okoro",
    role: "Traveler",
    text: "Landed in the city and had a Trailblazer waiting the same day. Support answered on WhatsApp at midnight. Truly 24/7 service.",
    avatar: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
  },
  {
    name: "Priya Nair",
    role: "Business Traveler",
    text: "Flexible monthly plan saved me a fortune. Well-maintained bikes and transparent deposit policy. Highly recommend Flyzone.",
    avatar: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
  },
];

export const FAQS = [
  {
    q: "How do I book a vehicle?",
    a: "Choose your scooter or motorcycle from the fleet, pick your dates and rental plan, upload your documents, and confirm. You'll get an instant confirmation by email and WhatsApp.",
  },
  {
    q: "Is a security deposit required?",
    a: "Yes. A refundable deposit is collected at pickup and returned within 3–5 business days after the vehicle is returned in good condition. The amount varies by vehicle class.",
  },
  {
    q: "What license do I need?",
    a: "A valid driving license for the vehicle category is required (scooter or motorcycle). International visitors should carry an International Driving Permit alongside their home-country license.",
  },
  {
    q: "What is the fuel policy?",
    a: "Vehicles are provided with a full tank and should be returned full. Electric models are handed over fully charged. A refuelling fee applies only if returned below the pickup level.",
  },
  {
    q: "Can I cancel or modify my booking?",
    a: "Absolutely. Free cancellation up to 24 hours before pickup with a full refund. Modifications to dates or vehicle are subject to availability at no extra charge.",
  },
  {
    q: "Is a helmet included?",
    a: "Every rental includes a certified helmet at no extra cost. Additional helmets for pillion riders are available on request.",
  },
  {
    q: "Which areas in Pune do you serve for bike rental?",
    a: "We're based in Kothrud and offer bike and scooter rental across Pune, including Hinjawadi, Wakad, Baner, Aundh, Kharadi, Hadapsar and Pimpri Chinchwad. We also arrange pickup near Pune Railway Station and Pune Airport on request.",
  },
  {
    q: "Do you offer self drive bike rental on daily, weekly and monthly plans?",
    a: "Yes. Flyzone offers affordable self drive bike rental in Pune with flexible hourly, daily, weekly and monthly plans — ideal for tourists, students and daily office commute. Book your bike online in minutes.",
  },
];

export const FEATURES = [
  { icon: "wallet", title: "Affordable Pricing", desc: "Transparent daily, weekly & monthly rates with zero hidden fees." },
  { icon: "wrench", title: "Well-Maintained Vehicles", desc: "Every ride is serviced, sanitised and safety-checked before pickup." },
  { icon: "monitor", title: "Easy Online Booking", desc: "Reserve in under two minutes from any device, anytime." },
  { icon: "headset", title: "24/7 Customer Support", desc: "Real humans on call and WhatsApp around the clock." },
  { icon: "helmet", title: "Helmet Included", desc: "Certified helmets provided free with every single rental." },
  { icon: "calendar", title: "Flexible Rental Plans", desc: "Hourly to monthly plans that flex around your schedule." },
];

export const STEPS = [
  { n: "01", title: "Choose Vehicle", desc: "Browse the fleet and pick the scooter or motorcycle that fits your ride." },
  { n: "02", title: "Upload Documents", desc: "Add your license and ID securely — verified in minutes." },
  { n: "03", title: "Confirm Booking", desc: "Select your plan, choose payment, and lock in your dates." },
  { n: "04", title: "Ride", desc: "Collect your keys and helmet, then hit the road with freedom." },
];
